import type { ChatAgentSnapshot } from './thread-agent-session';

/**
 * The question the user can answer now: the activity an unexpired open interrupt names, while no own
 * run is in flight (a running answer or send already covers the interrupts it was started with).
 */
export const findAnswerableQuestionId = ({ messages, openInterrupts, run }: ChatAgentSnapshot): string | null => {
    if (run.phase === 'running') return null;
    const answerableIds = new Set(openInterrupts.filter(({ isExpired }) => !isExpired).map(({ id }) => id));
    return messages.findLast((message) => message.role === 'activity' && answerableIds.has(message.id))?.id ?? null;
};
